// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { settleMount } from "#ce/framework/mount-ready";

/** Calls `callback` once every sp-select in `container` has mounted or failed, and at once when it holds none. */
export function withReadySelects(container, callback) {
  const controls = Array.from(container.querySelectorAll("sp-select"));

  if (!controls.length) {
    callback();

    return;
  }

  Promise.all(controls.map(settleMount)).then(callback);
}
